import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';

const CONFIRMATION_TEXT = 'DELETE';

const DeleteFeedDialog = ({ open, siteId, feedUrl, deleting, onClose, onConfirm }) => {
	const [confirmation, setConfirmation] = useState('');

	useEffect(() => {
		if (open) {
			setConfirmation('');
		}
	}, [open]);

	const isConfirmed = confirmation.trim().toUpperCase() === CONFIRMATION_TEXT;

	return (
		<Dialog open={open} onClose={deleting ? undefined : onClose} fullWidth maxWidth="sm">
			<DialogTitle>Delete RSS Feed</DialogTitle>
			<DialogContent>
				<Alert severity="warning" sx={{ mb: 2 }}>
					This permanently deletes the RSS feed for site {siteId}. Automated polling will stop and this
					cannot be undone.
				</Alert>
				{feedUrl && (
					<Typography variant="body2" color="text.secondary" sx={{ mb: 2, wordBreak: 'break-all' }}>
						Feed URL: {feedUrl}
					</Typography>
				)}
				<Alert severity="info" sx={{ mb: 2 }}>
					Deleting the feed only clears it locally in the site configuration. Update the site
					configuration afterwards to persist the change.
				</Alert>
				<Typography variant="body2" sx={{ mb: 1 }}>
					Type <strong>{CONFIRMATION_TEXT}</strong> to confirm.
				</Typography>
				<TextField
					fullWidth
					autoFocus
					value={confirmation}
					onChange={(e) => setConfirmation(e.target.value)}
					placeholder={CONFIRMATION_TEXT}
					disabled={deleting}
				/>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<Button onClick={onClose} disabled={deleting}>
					Cancel
				</Button>
				<LoadingButton variant="contained" color="error" onClick={onConfirm} loading={deleting} disabled={!isConfirmed}>
					Delete Feed
				</LoadingButton>
			</DialogActions>
		</Dialog>
	);
};

export default DeleteFeedDialog;
